// extracted by mini-css-extract-plugin
export default {"zoomControl":"style_zoomControl__+vxVG","zoomIcon":"style_zoomIcon__fa73S"};